import {Box, Skeleton} from '@mui/material';

import {departmentHealthSectionCardSx} from './departmentHealthSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export interface Props {
  embedded?: boolean;
}

export const DepartmentHealthRoleCoverageHealthSkeleton = ({embedded = false}: Props) => {
  const cardSx = embedded ? {...departmentHealthSectionCardSx, mb: 0} : departmentHealthSectionCardSx;

  return (
    <EmpionPaper sx={cardSx}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5}}>
        <Skeleton variant='circular' width={15} height={15} />
        <Skeleton variant='text' width={150} height={18} />
      </Box>
      <Skeleton variant='text' width='85%' height={14} sx={{mb: 2}} />
      {Array.from({length: 2}).map((_, index) => (
        <Box key={index} sx={{mb: 1.5, pb: 1.5, borderBottom: '0.5px solid', borderColor: 'divider'}}>
          <Skeleton variant='text' width='70%' height={16} sx={{mb: 1}} />
          <Skeleton variant='text' width='90%' height={14} />
          <Skeleton variant='text' width='80%' height={14} />
        </Box>
      ))}
    </EmpionPaper>
  );
};
